import script from "./PWAInstallBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PWAInstallBanner.vue?vue&type=script&setup=true&lang=js"

import "./PWAInstallBanner.vue?vue&type=style&index=0&id=1deaa83a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1deaa83a"]])

export default __exports__